<template>
  <v-card class="mb-4"
          v-if="team.uses_veeva_vault && presentation.vaultConfiguration">
    <v-card-title>
      <img src="/v2/images/veeva/veeva-vault-1.png"
           alt="Imported from Veeva Vault"
           style="height: 20px; width: auto;"
           class="mr-2"/>
      Veeva Vault Configuration
    </v-card-title>
    <v-simple-table>
      <tbody>
      <tr>
        <td>
          Vault Document Number
        </td>
        <td>
          {{ presentation.external_id }}
          <template v-if="isAdmin">
            <v-btn @click.prevent="synchronizeFromVault"
                   x-small>
              <v-icon left>
                fal fa-sync
              </v-icon>
              Synchronize from Veeva Vault
            </v-btn>
          </template>
        </td>
      </tr>
      <tr>
        <td>
          Connection
        </td>
        <td>
          {{ presentation.vaultConfiguration.vault_connection_id }}
        </td>
      </tr>
      <tr>
        <td>
          Vault Doc ID
        </td>
        <td>
          {{ presentation.vaultConfiguration.vault_doc_id }}
        </td>
      </tr>
      <tr>
        <td>
          Vault Doc Version
        </td>
        <td>
          {{ presentation.vaultConfiguration.vault_doc_version }}
        </td>
      </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';
import PresentationVaultIcon from '../../veeva_vault/components/PresentationVaultIcon';
import veevaVaultService from '../../../services/veevaVaultService';

export default {
  components: {PresentationVaultIcon},
  props: {
    presentation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'team',
      'user',
    ])
  },
  methods: {
    synchronizeFromVault() { // MLD-2493
      if (!this.presentation.vaultConfiguration) {
        return;
      }
      veevaVaultService.synchronizePresentation(this.presentation.id)
        .then(() => {
          this.$emit('updated');
        })
    }
  }
}
</script>
